<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between">
    <h5 class="mb-0">Mail Rule</h5>
    <ol class="breadcrumb mb-0 ps-0">
        <li class="breadcrumb-item">
            <a [routerLink]="'/' + routerUrl['mainLayout']">
                <i class="ri-home-8-line"></i>
                {{ "DASHBOARD.TITLE" | translate }}
            </a>
        </li>
        <li class="breadcrumb-item fw-semibold">
            {{ "Mail Rule" | translate }}
        </li>
    </ol>
</div>
<mat-card class="mb-25 tagus-card" #dialogContent>
    <mat-card-content>
        <div class="mail-rule-dialog-container">
            <div mat-dialog-title class="bg-gray py-4 d-flex justify-content-start" *ngIf="!isGlobal">
                <h4 class="w-100 m-0">Move Mails</h4>
                <i class="flaticon-close cursor-pointer fs-18 text-black" mat-dialog-close></i>
            </div>
            <app-move-mails selectedDomain="''" (scrollTop)="onScrollTop()" [isAdmin]="isGlobal"></app-move-mails>
        </div>
    </mat-card-content>
</mat-card>